import React from 'react'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import YumCopyButton from '../YumCopyButton/YumCopyButton'

interface YumReadOnlyFieldProps {
  label: string
  value: string
  showCopy?: boolean
}

export default function YumReadOnlyField({ label, value, showCopy = true }: YumReadOnlyFieldProps) {
  return (
    <TextField
      variant="filled"
      margin="dense"
      fullWidth
      label={label}
      value={value}
      InputProps={{
        readOnly: true,
        disableUnderline: true,
        style: { fontFamily: 'monospace', fontSize: 13 },
        endAdornment:
          showCopy && value ? (
            <InputAdornment position="end">
              <YumCopyButton text={value} />
            </InputAdornment>
          ) : undefined,
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  )
}
